// extracted by mini-css-extract-plugin
module.exports = {"main":"details_main__1obC0","upper_txt":"details_upper_txt__2Fekz","tag":"details_tag__1OD8O"};